type UnwatchCallback = (instanceKey: string) => void;

const TICK_MS = 500;

export const createUnwatchManager = (onUnwatch: UnwatchCallback) => {
  let collecting = new Set<string>();
  let pendingUnwatch = new Set<string>();
  let intervalId: ReturnType<typeof setInterval> | null = null;

  const tick = () => {
    for (const instanceKey of pendingUnwatch) {
      onUnwatch(instanceKey);
    }

    pendingUnwatch = collecting;
    collecting = new Set();

    if (pendingUnwatch.size === 0) {
      clearInterval(intervalId!);
      intervalId = null;
    }
  };

  return {
    queue: (instanceKey: string) => {
      collecting.add(instanceKey);

      if (intervalId === null) {
        intervalId = setInterval(tick, TICK_MS);
      }
    },
    clear: (instanceKey: string) => {
      collecting.delete(instanceKey);
      pendingUnwatch.delete(instanceKey);
    },
  };
};

export type UnwatchManager = ReturnType<typeof createUnwatchManager>;
